/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataCtmsItemRespVo } from './PageDataCtmsItemRespVo';
import {
    PageDataCtmsItemRespVoFromJSON,
    PageDataCtmsItemRespVoFromJSONTyped,
    PageDataCtmsItemRespVoToJSON,
    PageDataCtmsItemRespVoToJSONTyped,
} from './PageDataCtmsItemRespVo';

/**
 * 
 * @export
 * @interface ResponsePageDataCtmsItemRespVo
 */
export interface ResponsePageDataCtmsItemRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataCtmsItemRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataCtmsItemRespVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataCtmsItemRespVo}
     * @memberof ResponsePageDataCtmsItemRespVo
     */
    data?: PageDataCtmsItemRespVo;
}

/**
 * Check if a given object implements the ResponsePageDataCtmsItemRespVo interface.
 */
export function instanceOfResponsePageDataCtmsItemRespVo(value: object): value is ResponsePageDataCtmsItemRespVo {
    return true;
}

export function ResponsePageDataCtmsItemRespVoFromJSON(json: any): ResponsePageDataCtmsItemRespVo {
    return ResponsePageDataCtmsItemRespVoFromJSONTyped(json, false);
}

export function ResponsePageDataCtmsItemRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataCtmsItemRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataCtmsItemRespVoFromJSON(json['data']),
    };
}

export function ResponsePageDataCtmsItemRespVoToJSON(json: any): ResponsePageDataCtmsItemRespVo {
    return ResponsePageDataCtmsItemRespVoToJSONTyped(json, false);
}

export function ResponsePageDataCtmsItemRespVoToJSONTyped(value?: ResponsePageDataCtmsItemRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataCtmsItemRespVoToJSON(value['data']),
    };
}

